module.exports = __webpack_public_path__ + "media/images/logo_jutaku-c-954d8252d046943b8d52969af5b30268.png";